export default __webpack_public_path__ + "static/media/ic9.3eacb8d5.gif";